import React from "react";
import styled from "styled-components";
import { Button } from "@material-ui/core";
import { ACCESS_MODES, API_BASE_URLS } from "../utils/apiTarget";
import { getDbInterfaceRoutePath } from "./dbInterfaceConfig";

export const VPN_BANNER_VARIANTS = {
  unreachable: "unreachable",
  notViaVpn: "notViaVpn",
};

// Shown on the read-write link when the VPN-only API cannot be reached (VPN off, or CORS /
// DNS misconfiguration, which look identical from the browser) or when the server reports
// that the request did not arrive through the VPN host.
const DbInterfaceVpnBanner = ({ variant = VPN_BANNER_VARIANTS.unreachable, isDev, onRetry }) => {
  const hostName = (isDev ? API_BASE_URLS.vpnDevelopment : API_BASE_URLS.vpnProduction).replace("https://", "");
  const vpnName = isDev ? "DEV_VPN" : "TULU prod VPN";
  const readOnlyPath = getDbInterfaceRoutePath(ACCESS_MODES.readOnly, isDev) + window.location.search;

  return (
    <Banner role="alert">
      {variant === VPN_BANNER_VARIANTS.unreachable ? (
        <>
          <strong>Cannot reach {hostName}.</strong>
          <span>Connect to the {vpnName}, then click Retry. Reads still work on the read-only link.</span>
        </>
      ) : (
        <>
          <strong>This request did not arrive through the VPN host.</strong>
          <span>The server will reject writes. Check that you are connected to the {vpnName} and reload.</span>
        </>
      )}
      <Actions>
        {onRetry && (
          <Button size="small" variant="contained" color="primary" onClick={onRetry}>
            Retry
          </Button>
        )}
        <Button size="small" href={readOnlyPath}>
          Open read-only link
        </Button>
      </Actions>
    </Banner>
  );
};

export default DbInterfaceVpnBanner;

const Banner = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  margin: 12px;
  padding: 12px 16px;
  border-radius: 8px;
  background: #fbe6e4;
  border: 1px solid #f1b9b4;
  color: #5c1a15;
  font-size: 14px;
`;

const Actions = styled.div`
  display: flex;
  gap: 8px;
  margin-left: auto;
`;
